<template>
  <div class="loader" :class="isLoading?'loader--loading':''">
    <div class="loader__icon">
      <img src="../assets/loader.svg" alt="Caricamento..." class="img-fluid">
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLoader',
  computed: {
    isLoading() {
      return this.$store.getters.isLoading;
    }
  }
};
</script>